/**
 * 체험공간 오브젝트를 **무엇으로 표시할까** — 월드와 관리자 미리보기가 같은 판정을 쓴다.
 *
 * ## 왜 shared 인가
 * 관리자 배치 화면과 아이가 보는 월드는 **다른 파일**이 그린다. 판정을 따로 두면 아무 에러
 * 없이 갈리고, 운영자는 "관리자에선 이렇게 보이는데 화면은 다르다"만 겪는다(CLAUDE.md 규칙).
 *
 * ## 그림을 안 고르면 **동그란 빛**
 * 예전 기본값은 화살표 표지판(`decor.signpost`)이었고, 그것도 없으면 원+이모지였다.
 * 그런데 배경 그림에 이미 건물·입구가 그려진 마을에서는 표지판이 덧그려져 어수선했다.
 * 마을 입구의 존 선택지들이 이미 `marker: "none"` 으로 **빛+라벨만** 쓰고 있었고
 * (달밤 등불 느낌) 그 모습이 이 서비스의 기준이 됐다 — 그래서 **그걸 기본값으로 올린다.**
 *
 * 숨은 속성이던 `marker: "none"` 은 그대로 받는다(맵에 이미 들어 있다).
 *
 * ## 마을 친구(NPC)는 예외
 * 친구는 **모습이 보여야 한다.** 빛만 남기면 누가 있는지 알 수 없고, 표지판을 씌우면
 * "걸어 다니는 표지판"이 된다. 그림이 없으면 예전처럼 원+이모지로 둔다.
 */

/** 표시 방법. `light` = 소품 없이 동그란 빛 + 라벨(마을 선택지와 같은 모습). */
export type MarkerStyle = "npc" | "sprite" | "light";

export interface MarkerInput {
  type?: string;
  /** 운영자가 고른 그림(매니페스트 키). 빈 값이면 "안 골랐다". */
  sprite?: string;
  npc_sprite?: string;
  props?: Record<string, unknown>;
}

export function markerStyleOf(o: MarkerInput): MarkerStyle {
  // 친구는 언제나 사람 모습으로(그림이 없으면 호출부가 원+이모지로 폴백)
  if (o.type === "npc") return "npc";
  if (typeof o.sprite === "string" && o.sprite.trim() !== "") return "sprite";
  return "light";
}

/** 빛으로 표시되는가 — 관리자 화면이 "✨ 빛" 이라고 알려 줄 때 쓴다. */
export function isLightMarker(o: MarkerInput): boolean {
  return markerStyleOf(o) === "light";
}
